/* Stylesheets */
import './scss/vendors/bootstrap.scss' // ref: https://getbootstrap.com/docs/5.2/customize/sass/#importing
import './scss/vendors/swiper.scss' // ref: https://swiperjs.com/get-started#installation
import './scss/vendors/woocommerce.scss'
import './scss/vendors/leaflet.scss'
import './scss/parts/page-builder.scss'
import './scss/parts/product-builder.scss'
import './scss/parts/machine-configurator.scss'
import './scss/style.scss'


/* Scripts */
import $ from 'jquery'
require('jquery.easing')
var imagesLoaded = require('imagesloaded');
import { Accordion, Collapse, ScrollSpy, Modal, Tooltip } from 'bootstrap' // ref: https://getbootstrap.com/docs/5.2/getting-started/webpack/#import-bootstrap - Point 3.
import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper' // ref: https://swiperjs.com/get-started#install-from-npm
import BackgroundCheck from './js/background-check.min.js' // ref: https://www.kennethcachia.com/background-check/
import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText.js";
gsap.registerPlugin(SplitText);
import L from 'leaflet';
require('leaflet.markercluster/dist/leaflet.markercluster-src.js');
import 'jquery.idle/vanilla.idle.js';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import { library, dom } from '@fortawesome/fontawesome-svg-core' // ref: https://fontawesome.com/docs/web/setup/packages
import { faChevronLeft, faChevronRight, faUser, faBagShopping, faMagnifyingGlass, faBasketShoppingSimple, faMugHot, faFileUser, faAddressBook, faFileInvoice, faFolder, faFile, faFolderHeart, faHouse, faRightFromBracket, faCircleNotch, faXmark, faFileArrowDown, faSpinnerThird, faArrowRotateLeft } from '@fortawesome/pro-light-svg-icons'
import { faChevronLeft as faChevronLeftSolid, faChevronRight as faChevronRightSolid, faChevronUp, faChevronDown, faComment, faGlobe, faPlay, faXmark as faXmarkSolid, faHeart, faCircleInfo, faGear, faCircle, faList, faTrash, faTriangleExclamation, faCircleCheck, faCartPlus, faSquareRss, faLocationDot } from '@fortawesome/pro-solid-svg-icons'
import { faEarthEurope } from '@fortawesome/pro-regular-svg-icons'
import { faFacebook, faTwitter, faYoutube, faInstagram, faWhatsapp, faTelegram, faLinkedin, faPinterest, faWeibo } from '@fortawesome/free-brands-svg-icons'
library.add(faChevronLeft, faChevronRight, faUser, faBagShopping, faMagnifyingGlass, faBasketShoppingSimple, faMugHot, faFileUser, faAddressBook, faFileInvoice, faFolder, faFile, faFolderHeart, faHouse, faRightFromBracket, faCircleNotch, faPlay, faXmark, faFileArrowDown, faSpinnerThird, faArrowRotateLeft)
library.add(faChevronLeftSolid, faChevronRightSolid, faChevronUp, faChevronDown, faComment, faGlobe, faXmarkSolid, faHeart, faCircleInfo, faGear, faCircle, faList, faTrash, faTriangleExclamation, faCircleCheck, faCartPlus, faSquareRss, faLocationDot)
library.add(faEarthEurope)
library.add(faFacebook, faTwitter, faYoutube, faInstagram, faWhatsapp, faTelegram, faLinkedin, faPinterest, faWeibo)
dom.watch()


/* Init Functions on DOMContentLoaded */
const ready = (callback) => {
    if (document.readyState != "loading") callback()
    else document.addEventListener("DOMContentLoaded", callback)
};

const isDebug = process.env.NODE_ENV !== 'production'

/* Variables and functions */
let deviceWidth, deviceHeight;
let isAnimating = false;
let urlHash;
let lastScrollTop;
let totalScrollSections;
let scrollSpy;
let themePath, sitePath, wpmlLangPath;
let swiperProdLandingGallery, swiperProdLandingModalGallery, swiperProdLandingVideo, swiperWooGalleryModal;
let compareSelected = [];

// initWebpackVersion
const initWebpackVersion = () => {
    if (isDebug)
        console.log(`%c${DESCRIPTION}`, `color: #9ac456; font-size: 18px; font-weight: 700;`, `Version ${VERSION} - Development Environment`)
}


// Funzione per resize altezza (mobile)
let windowWidth = 0;
const appHeight = () => {
    const currentWindowWidth = window.innerWidth
    if (currentWindowWidth !== windowWidth) {
        windowWidth = currentWindowWidth
        const doc = document.documentElement
        doc.style.setProperty('--fix-100vh', `${window.innerHeight}px`)
        doc.style.setProperty('--fix-65vh', `${window.innerHeight - window.innerHeight/2.8}px`)
    }
}
appHeight()
window.addEventListener('resize', appHeight)


// Loading vari
const showLoading = () => {
    $('.loading-form').show();
}

const hideLoading = () => {
    $('.loading-form').hide();
}

const showLoadingForm = () => {
    $('#btnLoader').show();
    $('#btnSendForm').hide();
}

const hideLoadingForm = () => {
    $('#btnLoader').hide();
    $('#btnSendForm').show();
}


// inViewport function
(function ($, win) {
    $.fn.inViewport = function (cb) {
        return this.each(function (i, el) {
            function visPx() {
                var H = $(this).height();
                var r = el.getBoundingClientRect(), t = r.top, b = r.bottom;
                return cb.call(el, Math.max(0, t > 0 ? H - t : b < H ? b : H));
            } visPx();
            $(win).on("resize scroll DOMContentLoaded", visPx);
        });
    };
}(jQuery, window));


// scrollToSection
const scrollToSection = (id, vel) => {
    isAnimating = true;
    if (vel == null) vel = 1200;
    if(typeof id === "number"){
        var target = $('section[data-index=' + id + ']');
        var puntoArrivo = target.offset().top;
        if(target.outerHeight() < deviceHeight){
            puntoArrivo = target.offset().top - (deviceHeight - target.outerHeight());
        }
    } else {
        var puntoArrivo = $('*[data-anchor=' + id + ']').offset().top;
    }
    if (vel == 0) {
        $('body, html').scrollTop(puntoArrivo);
    } else {
        $('body, html').animate({
            scrollTop: puntoArrivo
        }, vel, 'easeInOutQuart', function () {
            isAnimating = false;

            if($('body, html').scrollTop() == 0){
                let layerScroll = document.querySelector('.prod-landing');
                if(layerScroll){
                    initScrollSpy();
                }
            }
        });
    }
}


// scrollToHash
const scrollToHash = (hash) => {
    if(hash){
        if ($('*[data-anchor=' + hash + ']').length > 0) {
            isAnimating = true;
            var puntoArrivo = $('*[data-anchor=' + hash + ']').offset().top;
            $('body, html').animate({
                scrollTop: puntoArrivo
            }, 1000, 'easeInOutQuart', function () {
                isAnimating = false;
            });
        }
    }
}

$(window).on('resize', function () {
    deviceWidth = $(window).width();
    deviceHeight = $(window).height();
});

$(window).on('scroll', function () {
    checkScrollTop();
});

$(window).on('hashchange', function () {
    urlHash = location.hash.replace(/^#/, '');
    scrollToHash(urlHash);
});


// checkScrollTop
const checkScrollTop = () => {

    let st = window.pageYOffset || document.documentElement.scrollTop;
    let st_bot = st + deviceHeight -1;
    let isProductLanding = document.querySelector('.prod-landing');
    let isProductConfigurator = document.querySelector('.machine-configurator');

    if (st > lastScrollTop && st > 1) {
        $('header').addClass('away');
    } else {
        $('header').removeClass('away');
    }
    if (st > 10) {
        $('header').addClass('bg-active');
    } else {
        $('header').removeClass('bg-active');
    }
    if(st > deviceHeight/2){
        $('#btnScrollUpPage').removeClass('away');
    } else {
        $('#btnScrollUpPage').addClass('away');
    }

    let footerYpos = $('footer').position().top
    if(st_bot >= footerYpos){
        $('.pages-vert-side-img').addClass('abs');
    } else {
        $('.pages-vert-side-img').removeClass('abs');
    }

    if(isProductLanding){
        if($('.intro').length > 0 && $('section.bottom-img').length > 0){
            if(st >= ($('.intro').offset().top + $('.intro').outerHeight() / 2) && st_bot <= ($('section.bottom-img').offset().top + $('section.bottom-img').outerHeight() / 2.5)){
                if(deviceWidth > 1200){
                    $('.side-dots').addClass('is-visible');
                }
            } else {
                if(deviceWidth > 1200){
                    $('.side-dots').removeClass('is-visible');
                }
            }

            if(st >= $('.intro').offset().top && st_bot <= ($('section.bottom-img').offset().top + $('section.bottom-img').outerHeight() / 2.5)){
                $('.lower-bar').addClass('is-visible');
            } else {
                $('.lower-bar').removeClass('is-visible');
            }
        }
    }

    if(isProductConfigurator){
        if(st_bot <= $('footer').offset().top){
            $('.lower-bar, .side-tools').addClass('is-visible');
        } else {
            $('.lower-bar, .side-tools').removeClass('is-visible');
        }
    }

    lastScrollTop = st <= 0 ? 0 : st;
}


// initMainMenu
const initMainMenu = () => {

    let currentCategory = '';
    let wasLMHome = $('body').hasClass('lm-home');

    // Hamburger mobile
    $('header .hamburger').on('click', function() {
        $(this).toggleClass('is-active');
        $('header, .dark-layer-menu').toggleClass('is-active');
        $('body').toggleClass('menu-is-active');
        if($(this).hasClass('is-active')){
            $('#mainMenu .section-img').removeClass('first active');
            $('#mainMenu .section-img[data-primary="0"]').addClass('first active');
            $('#mainMenu .wrap-primary').addClass('active');
            $('#mainMenu .wrap-secondary').removeClass('active');
            $('#mainMenu .secondary a').removeClass('selected');
            $('#mainMenu .wrap-secondary.active .wrap-tertiary').hide();
            $('#mainMenu .wrap-secondary.active .tertiary').removeClass('active');
            $('#mainMenu .wrap-secondary .row.slide-mobile').removeClass('viewing-level-3');
            $('header').removeClass('bg-active');

            if(wasLMHome){
                $('header nav .lm-home-trigger').trigger('click');
                BackgroundCheck.set('targets', '.check-color-target-icons');
                BackgroundCheck.set('images', '.section-img-inner-wrap');
            } else {
                setTimeout(function(){
                    $('body').removeClass('lm-home');
                }, 500);
                BackgroundCheck.set('targets', '.check-color-target-icons');
                BackgroundCheck.set('images', '.section-img-inner-wrap');
                animMenu('primary');
            }
        } else {
            setTimeout(function(){
                if(!wasLMHome) {
                    $('body').removeClass('lm-home');
                } else {
                    $('body').addClass('lm-home');
                }
            }, 500);
            BackgroundCheck.set('targets', '.check-color-target, .check-color-target-logo, .check-color-target-icons');
            BackgroundCheck.set('images', $('.check-color-images').length > 0 ? '.check-color-images' : '.check-color-target-fake');
            checkScrollTop();
        }
    });

    // Primary links
    $('#mainMenu .primary a').on('click', function(){
        $('#mainMenu .wrap-primary').removeClass('active');
        $('#mainMenu .section-img[data-primary="0"]').removeClass('first');
        if($('#mainMenu .wrap-secondary[data-primary="' + $(this).data('index') + '"]').length > 0){
            $('#mainMenu .wrap-secondary[data-primary="' + $(this).data('index') + '"]').addClass('active');
            $('#mainMenu .secondary a').removeClass('selected');
            $('#mainMenu .wrap-secondary.active .wrap-tertiary').hide();
            $('#mainMenu .wrap-secondary.active .tertiary').removeClass('active');
            $('#mainMenu .wrap-secondary.active .btn-back-category span').text($('#mainMenu .wrap-secondary.active .btn-back-category').data('primary-category'));
            $('#mainMenu .section-img').removeClass('active');
            $('#mainMenu .section-img[data-primary="' + $(this).data('index') + '"]').addClass('active');
            if($(this).hasClass('lm-home-trigger')){
                $('body').addClass('lm-home');
            } else {
                $('body').removeClass('lm-home');
            }
            BackgroundCheck.refresh();
            animMenu('secondary', $(this).data('index'));
        }
    });

    // Secondary links
    $('#mainMenu .secondary a').on('click', function(){
        $('#mainMenu .secondary a').removeClass('selected');
        if($('#mainMenu .wrap-secondary.active .tertiary[data-parent="' + $(this).data('index') + '"] li').length > 0){
            $(this).addClass('selected');
            $('#mainMenu .wrap-secondary.active .wrap-tertiary').show();
            $('#mainMenu .wrap-secondary.active .tertiary').removeClass('active');
            $('#mainMenu .wrap-secondary.active .tertiary[data-parent="' + $(this).data('index') + '"]').addClass('active');
            if(deviceWidth < 768){
                $('#mainMenu .wrap-secondary.active .row.slide-mobile').addClass('viewing-level-3');
                currentCategory = $('#mainMenu .wrap-secondary.active .btn-back-category span').text();
                $('#mainMenu .wrap-secondary.active .btn-back-category span').text($(this).text());
            }
            animMenu('tertiary', $(this).data('index'));
        } else {
            $('#mainMenu .wrap-secondary.active .wrap-tertiary').hide();
        }
    });

    // Back button
    $('#mainMenu .btn-back-category a').on('click', function(){
        if($('#mainMenu .wrap-secondary.active .row.slide-mobile').hasClass('viewing-level-3')){
            $('#mainMenu .secondary a').removeClass('selected');
            $('#mainMenu .wrap-secondary.active .row.slide-mobile').removeClass('viewing-level-3');
            $('#mainMenu .wrap-secondary.active .btn-back-category span').text(currentCategory);
        } else {
            $('#mainMenu .wrap-secondary').removeClass('active');
            $('#mainMenu .wrap-primary').addClass('active');
            $('#mainMenu .section-img').removeClass('active');
            $('#mainMenu .section-img[data-primary="0"]').addClass('active');
            $('body').removeClass('lm-home');
        }
        BackgroundCheck.refresh();
    });

    // Accessibility: toggle aria-expanded on language switch
    $('.lang-switch .current-lang').on('click', function(){
        $(this).attr('aria-expanded', function(index, attr){
            return attr === "true" ? "false" : "true";
        });
    });

    // Animations
    const animMenu = (type, parent) => {
        let menuList = document.querySelectorAll('#mainMenu .' + type + ' li');
        let delay = .5;
        if(parent){
            if(type == "secondary"){
                menuList = document.querySelectorAll('#mainMenu .wrap-secondary[data-primary="' + parent + '"] ul.secondary > li');
                delay = .3;
            }
            if(type == "tertiary"){
                menuList = document.querySelectorAll('#mainMenu .wrap-secondary.active ul.tertiary[data-parent="' + parent + '"] > li');
                if(deviceWidth >= 1024){
                    delay = 0;
                } else {
                    delay = .3;
                }
            }
        }
        if(type == "tertiary"){
            if(deviceWidth > 576){
                gsap.fromTo(menuList, { autoAlpha: 0, translateX: '-5%' }, { autoAlpha: 1, translateX: 0, duration: .8, stagger: .1, delay: delay, ease: "expo.out" });
            }
        } else {
            gsap.fromTo(menuList, { autoAlpha: 0, translateX: '-10%' }, { autoAlpha: 1, translateX: 0, duration: 1.6, stagger: .1, delay: delay, ease: "expo.out" });
        }
    }
}


// initMyAccount
const initMyAccount = () => {
    $('.my-account-header .hamburger').on('click', function() {
        $(this).toggleClass('is-active');
        $('.my-account-wrap-menu').toggleClass('d-none');
    });
}


// pagesVertSideImg
const pagesVertSideImg = () => {
    if(!$('body').hasClass('page-template-product-landing')){

        // Page preload
        var imgLoad = imagesLoaded('body', { background: '.got-bg' }, function(instance) {
            let sideImg = document.querySelectorAll('.pages-vert-side-img');
            if(sideImg && sideImg.length > 0){
                sideImg[0].classList.add('active');
                BackgroundCheck.refresh();
            }
        });

    }
}


// initProductPage
const initProductPage = () => {

    let layerScroll = document.querySelector('.prod-landing');

    if(layerScroll){

        // Read more
        $('.prod-text-toggle').on('click', function(){
            $(this).hide().parent().parent().find('.d-none').removeClass('d-none');
        });

        // #btnScrollUpPage absolute
        $('#btnScrollUpPage').addClass('position-absolute');

        // Modal photo gallery
        let galleryModal = document.getElementById('galleryModal');
        if(galleryModal){
            const modalGallery = new Modal(galleryModal);
            $('section.gallery .swiper a.lnk-modal').on('click', function(){
                swiperProdLandingModalGallery.slideToLoop($(this).parent().parent().data('swiper-slide-index'));
                modalGallery.show();
            })
        }

        // Modal video gallery
        let videoModal = document.getElementById('videoModal');
        if(videoModal){
            const modalVideo = new Modal(videoModal);
            $('section.video-gallery .swiper .ratio a').on('click', function(){
                $('#videoModal .ratio').html('<iframe width="560" height="315" src="https://www.youtube.com/embed/' + $(this).data('video-id') + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>');
                $('.lower-bar').addClass('dark');
                $('.lower-bar .btn-dark').addClass('btn-light').removeClass('btn-dark');
                modalVideo.show();
            })
            videoModal.addEventListener('hidden.bs.modal', event => {
                $('#videoModal .ratio').html('');
                $('.lower-bar').removeClass('dark');
                if(!$('body').hasClass('lm-home')){
                    $('.lower-bar .btn-light').removeClass('btn-light').addClass('btn-dark');
                }
            })
        }

        // Other products
        $('section.other-products .secondary ul li a').on('click', function(){
            $('section.other-products .tertiary ul').addClass('d-md-none');
            $('section.other-products .tertiary ul.' + $(this).data('cat')).removeClass('d-md-none');

            $('section.other-products .secondary ul li a').removeClass('selected');
            $(this).addClass('selected');
        });

        initScrollSpy();

        // Page preload
        var imgLoad = imagesLoaded('body', { background: '.got-bg' }, function(instance) {

            let initialDelay = .9;
            if(deviceWidth < 1200){
                initialDelay = 0;
            }

            // Hide loading
            $('.hero .loading').remove();

            // Hero - vertical image
            let sideImg = document.querySelectorAll('.pages-vert-side-img');
            if(sideImg) sideImg[0].classList.add('active');
            BackgroundCheck.refresh();

            // Header - right icons
            if(deviceWidth >= 1200){
                gsap.fromTo('header .init-anim', { autoAlpha: 0 }, { autoAlpha: 1, duration: .6, delay: initialDelay, ease: "expo.out" });
            }
            $('header .init-anim').removeClass('init-anim');

            // Hero - product image
            gsap.fromTo('.hero--img', { autoAlpha: 0, translateY: '100%' }, { autoAlpha: 1, translateY: 0, duration: 1.6, delay: initialDelay, ease: "expo.out" });
            $('.hero--img').removeClass('init-anim');

            // Hero - product texts
            var heroClaim = new SplitText('.hero--wrap-prod .claim', {
                type: 'lines'
            });
            gsap.fromTo('.hero--wrap-prod h1', { autoAlpha: 0, translateX: '10%' }, { autoAlpha: 1, translateX: 0, duration: 1.6, delay: initialDelay + .95, ease: "expo.out" });
            gsap.fromTo(heroClaim.lines, { autoAlpha: 0, translateX: '10%' }, { autoAlpha: 1, translateX: 0, duration: 1.6, stagger: .1, delay: initialDelay + 1.35, ease: "expo.out", onComplete: function(){
                    //heroClaim.revert();
                }
            });
            $('.hero--wrap-prod h1').removeClass('init-anim');
            $('.hero--wrap-prod .claim').removeClass('init-anim');

            // Hero - scroll down element
            gsap.fromTo('.scroll-down', { autoAlpha: 0, translateY: '100%' }, { autoAlpha: 1, translateY: 0, duration: 1.6, delay: initialDelay + 2.15, ease: "expo.out" });
            $('.scroll-down').removeClass('init-anim');

            // Hero - price-cta bottom left
            gsap.fromTo('.price-cta', { autoAlpha: 0 }, { autoAlpha: 1, duration: 1.6, delay: initialDelay + 2.15, ease: "expo.out" });
            $('.price-cta').removeClass('init-anim');
        });

        // Intro
        if($('section.intro')){
            $('section.intro').inViewport(function (px) {
                if (px && !$(this).attr('animated')) {
                    $(this).attr('animated', true);

                    // Intro - title, breadcrumbs and paragraphs
                    gsap.fromTo('section.intro .bread-wrap', { autoAlpha: 0 }, { autoAlpha: 1, duration: 1.6, delay: 1, ease: "expo.out" });
                    var introTitle = new SplitText('section.intro .title', {
                        type: 'lines'
                    });
                    gsap.fromTo(introTitle.lines, { autoAlpha: 0, translateX: '10%' }, { autoAlpha: 1, translateX: 0, duration: 1.6, stagger: .1, delay: 1, ease: "expo.out", onComplete: function(){
                            //introTitle.revert();
                        }
                    });
                    gsap.fromTo('section.intro .text-columns', { autoAlpha: 0 }, { autoAlpha: 1, duration: 1.6, delay: 1.6, ease: "expo.out" });
                    $('section.intro .init-anim').removeClass('init-anim');
                }
            });
        }

        // Highlights
        if($('#highlights')){

            // Highlights - side image
            $('#highlights').inViewport(function (px) {
                if (px && !$(this).attr('animated')) {
                    $(this).attr('animated', true);
                    $('#highlights .pages-vert-side-img').addClass('active');
                }
            });

            // Highlights - texts
            $('.highlights--wrap-text').inViewport(function (px) {
                if (px && !$(this).attr('animated')) {
                    $(this).attr('animated', true);
                    $('.highlights--item').each(function(i, el){
                        var hlTitle = el.querySelector('h3');
                        var hlText = el.querySelector('p');
                        var highlightsDesc = new SplitText(hlText, {
                            type: 'lines'
                        });
                        gsap.fromTo(hlTitle, { autoAlpha: 0, translateX: '10%' }, { autoAlpha: 1, translateX: 0, duration: 1.6, delay: 1, ease: "expo.out" });
                        gsap.fromTo(highlightsDesc.lines, { autoAlpha: 0, translateX: '10%' }, { autoAlpha: 1, translateX: 0, duration: 1.6, stagger: .1, delay: 1, ease: "expo.out", onComplete: function(){
                                //highlightsDesc.revert();
                            }
                        });
                        $(el).removeClass('init-anim');
                    });
                }
            });
        }

        // Gallery
        if($('#gallery')){
            $('#gallery').inViewport(function (px) {
                if (px && !$(this).attr('animated')) {
                    $(this).attr('animated', true);
                    $('#gallery .swiper').removeClass('init-anim');
                }
            });
        }

        // Videos
        if($('#videos')){
            $('#videos').inViewport(function (px) {
                if (px && !$(this).attr('animated')) {
                    $(this).attr('animated', true);
                    $('#videos .swiper').removeClass('init-anim');
                }
            });
        }

        // Features
        if($('#features')){
            $('#features').inViewport(function (px) {
                if (px && !$(this).attr('animated')) {
                    $(this).attr('animated', true);
                    gsap.fromTo('#features .title', { autoAlpha: 0, translateX: '10%' }, { autoAlpha: 1, translateX: 0, duration: 1.6, delay: .7, ease: "expo.out" });
                    $('#features .row').removeClass('init-anim');
                }
            });
        }

        // Specifications
        if($('#specifications')){
            $('#specifications').inViewport(function (px) {
                if (px && !$(this).attr('animated')) {
                    $(this).attr('animated', true);
                    gsap.fromTo('#specifications .title', { autoAlpha: 0, translateX: '10%' }, { autoAlpha: 1, translateX: 0, duration: 1.6, delay: .7, ease: "expo.out" });
                    $('#specifications dl, #specifications .table-responsive').removeClass('init-anim');
                }
            });
        }

        // Download
        if($('#download')){
            $('#download').inViewport(function (px) {
                if (px && !$(this).attr('animated')) {
                    $(this).attr('animated', true);
                    gsap.fromTo('#download .title', { autoAlpha: 0, translateX: '10%' }, { autoAlpha: 1, translateX: 0, duration: 1.6, delay: .7, ease: "expo.out" });
                    $('#download .row').removeClass('init-anim');
                }
            });
        }

        // Other products
        if($('#other_products')){
            $('#other_products').inViewport(function (px) {
                if (px && !$(this).attr('animated')) {
                    $(this).attr('animated', true);
                    gsap.fromTo('#other_products .title', { autoAlpha: 0, translateX: '10%' }, { autoAlpha: 1, translateX: 0, duration: 1.6, delay: .7, ease: "expo.out" });
                    $('#other_products .row').removeClass('init-anim');
                }
            });
        }
    }
}


// initAnimations
const initAnimations = () => {

    // sliderHeroMainV2
    let sliderHeroMainV2 = document.querySelectorAll('section.hero-main-v2 .swiper');
    if (sliderHeroMainV2) {
        sliderHeroMainV2.forEach(el => {
            let swiperHeroMainV2 = new Swiper(el, {
                modules: [Navigation, Pagination, Autoplay],
                speed: 1000,
                loop: true,
                autoHeight: true,
                slidesPerView: 1,
                spaceBetween: 0,
                autoplay: {
                    delay: 8000
                },
                pagination: {
                    el: el.querySelector(".swiper-pagination"),
                    type: "progressbar",
                },
                navigation: {
                    nextEl: el.querySelector('.swiper-navigation-btns .btn-next'),
                    prevEl: el.querySelector('.swiper-navigation-btns .btn-prev'),
                    lockClass: 'd-none'
                },
                on: {
                    afterInit: function(swiper){
                        heroV2TextAnim(swiper, 0.5, true);
                        el.querySelector('.swiper-navigation-btns').classList.remove('invisible');
                        el.querySelector('.swiper-pagination').classList.remove('invisible');
                    },
                    slideChangeTransitionEnd: function(swiper){
                        heroV2TextAnim(swiper, 0, false);
                        if(!$('body').hasClass('menu-is-active')){
                            BackgroundCheck.refresh();
                        }
                    }
                }
            });
        });

        function heroV2TextAnim(swiper, initDelay, isInit){
            swiper.slides.forEach(slide => {
                if($(slide).hasClass('swiper-slide-active')){
                    let $textWrap = $(slide).find('.hero-main--text-wrap');

                    let textStartXpos = $textWrap.hasClass('text-lg-end') ? '-10%' : '10%';
                    if(deviceWidth < 1024){
                        textStartXpos = '10%';
                    }

                    // Hero - title
                    let $title = $textWrap.find('.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6');
                    gsap.fromTo($title, { autoAlpha: 0, translateX: textStartXpos }, { autoAlpha: 1, translateX: 0, duration: 1.6, delay: initDelay, ease: "expo.out" });

                    // Hero - paragraph
                    let $p = $textWrap.find('p:not(:empty)');
                    var textParag = new SplitText($p, {
                        type: 'lines'
                    });
                    gsap.fromTo(textParag.lines, { autoAlpha: 0, translateX: textStartXpos }, { autoAlpha: 1, translateX: 0, duration: 1.6, stagger: .1, delay: initDelay + .2, ease: "expo.out", onComplete: function(){
                            //textParag.revert();
                        }
                    });

                    // Hero - btns
                    gsap.fromTo($textWrap.find('.wrap-btns'), { autoAlpha: 0, translateY: '50px' }, { autoAlpha: 1, translateY: 0, duration: 1.6, delay: initDelay + .4, ease: "expo.out" });
                    $textWrap.removeClass('init-anim');

                } else {
                    $(slide).find('.hero-main--text-wrap').addClass('init-anim');
                }
            });

            if(isInit){
                // Hero - scroll down element
                gsap.fromTo('.scroll-down', { autoAlpha: 0, translateY: '100%' }, { autoAlpha: 1, translateY: 0, duration: 1.6, delay: initDelay + 1, ease: "expo.out" });
                $('.scroll-down').removeClass('init-anim');
            }
        }
    }

    // sliderProducts
    let sliderProducts = document.querySelectorAll('section.product-slider .swiper');
    if (sliderProducts) {
        sliderProducts.forEach(el => {
            let swiperProducts = new Swiper(el, {
                modules: [Navigation, Pagination],
                speed: 1000,
                loop: true,
                autoHeight: true,
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: {
                    el: el.querySelector(".swiper-pagination"),
                    type: "progressbar",
                },
                navigation: {
                    nextEl: el.querySelector('.btn-next'),
                    prevEl: el.querySelector('.btn-prev'),
                    lockClass: 'd-none'
                },
                on: {
                    afterInit: function(swiper){
                        if($(swiper.el).attr('animated') == true){
                            if(el.hasAttribute('data-animations')){
                                sliderProductsTextAnim(swiper, 0.5, true);
                            }
                        }
                    },
                    slideChangeTransitionEnd: function(swiper){
                        if(el.hasAttribute('data-animations')){
                            sliderProductsTextAnim(swiper, 0, false);
                        }
                    }
                }
            });
            if(el.hasAttribute('data-animations')){
                $(el).inViewport(function (px) {
                    if (px && !$(this).attr('animated')) {
                        $(this).attr('animated', true);
                        sliderProductsTextAnim(swiperProducts, 0.5, true);
                    }
                });
            }
        });

        function sliderProductsTextAnim(swiper, initDelay, isInit){
            swiper.slides.forEach(slide => {
                if($(slide).hasClass('swiper-slide-active')){
                    let $textWrap = $(slide).find('.product-slider--text-wrap');

                    let textStartXpos = $textWrap.hasClass('text-lg-end') ? '-10%' : '10%';
                    if(deviceWidth < 1024){
                        textStartXpos = '10%';
                    }

                    // Slider product - title
                    let $title = $textWrap.find('.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6');
                    gsap.fromTo($title, { autoAlpha: 0, translateX: textStartXpos }, { autoAlpha: 1, translateX: 0, duration: 1.6, delay: initDelay, ease: "expo.out" });

                    // Slider product - paragraph
                    let $p = $textWrap.find('p:not(:empty)');
                    var textParag = new SplitText($p, {
                        type: 'lines'
                    });
                    gsap.fromTo(textParag.lines, { autoAlpha: 0, translateX: textStartXpos }, { autoAlpha: 1, translateX: 0, duration: 1.6, stagger: .1, delay: initDelay + .2, ease: "expo.out", onComplete: function(){
                            //textParag.revert();
                        }
                    });

                    // Slider product - btns
                    gsap.fromTo($textWrap.find('.wrap-btns'), { autoAlpha: 0, translateY: '30px' }, { autoAlpha: 1, translateY: 0, duration: 1.6, delay: initDelay + .4, ease: "expo.out" });
                    $textWrap.removeClass('init-anim');

                } else {
                    $(slide).find('.product-slider--text-wrap').addClass('init-anim');
                }
            });
        }
    }

    // Section with text and images
    let sectionTextImages = document.querySelectorAll('section.text-images .section-inner .text-images--text-wrap');
    if (sectionTextImages) {
        sectionTextImages.forEach(el => {
            if(el.hasAttribute('data-animations')){

                $(el).inViewport(function (px) {
                    if (px && !$(this).attr('animated')) {
                        $(this).attr('animated', true);

                        let $textWrap = $(el);

                        let textStartXpos = $textWrap.hasClass('text-lg-end') ? '-10%' : '10%';
                        if(deviceWidth < 1024){
                            textStartXpos = '10%';
                        }

                        // Titles
                        let $title = $textWrap.find('.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6');
                        gsap.fromTo($title, { autoAlpha: 0, translateX: textStartXpos }, { autoAlpha: 1, translateX: 0, duration: 1.6, delay: .5, ease: "expo.out" });

                        // Paragraphs
                        let $p = $textWrap.find('p:not(:empty)');
                        var textParag = new SplitText($p, {
                            type: 'lines'
                        });
                        gsap.fromTo(textParag.lines, { autoAlpha: 0, translateX: textStartXpos }, { autoAlpha: 1, translateX: 0, duration: 1.6, stagger: .1, delay: .7, ease: "expo.out", onComplete: function(){
                                //textParag.revert();
                            }
                        });

                        // Buttons
                        gsap.fromTo($textWrap.find('.wrap-btns'), { autoAlpha: 0, translateY: '30px' }, { autoAlpha: 1, translateY: 0, duration: 1.6, delay: .9, ease: "expo.out" });

                        // Remove init-anim class
                        $(el).removeClass('init-anim');
                    }
                });

            }
        });
    }

    // hand-grinder
    $('.hand-grinder').inViewport(function (px) {
        if (px && !$(this).attr('animated')) {
            $(this).attr('animated', true);
            $(this).addClass('is-visible');
        }
    });
}


// initWooProductPage
const initWooProductPage = () => {
    let isWooProductPage = document.querySelector('.single-prod--wrapper');

    if(isWooProductPage){
        // Initialize only the thumbnail gallery slider
        let swiperWooProdGallery;
        
        let sliderWooProdGallery = document.querySelector('.single-prod--gallery .swiper');
        if (sliderWooProdGallery) {
            swiperWooProdGallery = new Swiper(sliderWooProdGallery, {
                modules: [Navigation, Pagination],
                speed: 1000,
                loop: false,
                slidesPerView: 1,
                spaceBetween: 15,
                centerInsufficientSlides: true,
                navigation: {
                    nextEl: sliderWooProdGallery.querySelector('.swiper-navigation-btns .btn-next'),
                    prevEl: sliderWooProdGallery.querySelector('.swiper-navigation-btns .btn-prev'),
                    lockClass: 'd-none'
                },
                pagination: {
                    el: sliderWooProdGallery.querySelector(".swiper-pagination"),
                    type: "progressbar",
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        loop: false
                    },
                    1024: {
                        slidesPerView: 3,
                        loop: false,
                        spaceBetween: 25
                    }
                }
            });
        }

        // Set up the modal and its controls
        let galleryModalItem = document.getElementById('galleryModal');
        if(galleryModalItem){
            // Handle main product image click
            $('.woocommerce-product-gallery__wrapper a').off('click').on('click', function(e){
                e.preventDefault();
                
                if($('.single-prod--gallery .swiper-slide').length > 0){
                    // Set index to 0 for main image and position the slider
                    if (window.modalSwiperInstance) {
                        // Use slideTo with no animation before the modal is shown
                        window.modalSwiperInstance.slideTo(0, 0);
                    }
                    
                    // Show the modal
                    const bsModal = new Modal(galleryModalItem);
                    bsModal.show();
                } else {
                    // Simple image modal if no gallery
                    $('#galleryModalImg').attr('src', $(this).attr('href'));
                    const bsModal = new Modal(galleryModalItem);
                    bsModal.show();
                }
            });
            
            // Initialize the gallery fix (this handles click events for thumbnails
            // and sets up the modal slider correctly)
            if (typeof window.fixWooGalleryModal === 'function') {
                window.fixWooGalleryModal();
            }
        }
    }
}

// initWooProductConfigurator
const initWooProductConfigurator = () => {
    let isConfigurator = document.querySelector('.machine-configurator');

    if(isConfigurator){

        setTimeout(function(){
            $('.side-tools .btn-nav-arrow').removeClass('always-on');
        }, 3000);

        // Slider configuratore
        let sliderItemsNav = document.querySelector('.machine-configurator .navigation .swiper');
        if (sliderItemsNav) {
            let swiperSliderItemsNav = new Swiper(sliderItemsNav, {
                modules: [Navigation, Pagination, EffectFade],
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                speed: 1000,
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                autoHeight: true,
                navigation: {
                    nextEl: sliderItemsNav.querySelector('.btn-next'),
                    prevEl: sliderItemsNav.querySelector('.btn-prev')
                },
                pagination: {
                    el: sliderItemsNav.querySelector(".swiper-pagination"),
                    type: "progressbar",
                },
                on: {
                    afterInit: function(swiper) {
                        $('.navigation .swiper-top-bar .item-title').text($(swiper.el).find('.swiper-slide-active').data('title'));
                        $('.navigation .swiper-top-bar .paginator-numbers .current').text(swiper.activeIndex+1);
                        $('.navigation .swiper-top-bar .paginator-numbers .total').text(swiper.slides.length);
                        $('#mainLoader').addClass('invisible');
                        $('#canvas_3d canvas').show();

                        //if(deviceWidth >= 1024){
                            $('#swiperComponentTemplate, .swiper-top-bar, .swiper-pagination-progressbar').addClass('is-active');
                            $('.machine-configurator .navigation .swiper .btn-wrap').addClass('is-active');
                        //}
                    },
                    slideChangeTransitionStart: function (swiper) {
                        $('.navigation .swiper-top-bar .item-title').text($(swiper.el).find('.swiper-slide-active').data('title'));
                        $('.navigation .swiper-top-bar .paginator-numbers .current').text(swiper.activeIndex+1);
                    }
                }
            });
        }

        // View list open/close functions
        $('.btn-view-list').on('click', function(){
            $('.lower-bar').addClass('is-active');
            $('.machine-container').addClass('away').on('click', function(){
                $('.btn-close-list').trigger('click');
            });
        });
        $('.btn-close-list').on('click', function(){
            $('.lower-bar').removeClass('is-active');
            $('.machine-container').removeClass('away').off('click');
        });
        $('.btn-config-tool').on('click', function(){
            $('#swiperComponentTemplate, .swiper-top-bar, .swiper-pagination-progressbar').toggleClass('is-active');
            $('.machine-configurator .navigation .swiper .btn-wrap').toggleClass('is-active');
            $(this).toggleClass('is-active');
        });

        // Click on component items
        $('.machine-configurator .navigation .item-wrap .item').on('click', function () {
            const componentId = $(this).closest('.swiper-slide').data('component-id');
            const optionId = $(this).data('option-id');
            $('select#component_options_' + componentId).val(optionId).trigger('change');
        });
    }
}


// ScrollSpy
const initScrollSpy = () => {
    scrollSpy = new ScrollSpy(document.body, {
        target: '#sideDots',
        smoothScroll: true,
        threshold: [0.25]
    })
    totalScrollSections = $('.side-dots .dot').length;

    document.body.addEventListener('activate.bs.scrollspy', (e) => {
        $('.side-dots .dots-label').text(e.relatedTarget.dataset.name);
    })

    $('.side-dots .dot').on('mouseenter', function(){
        $('.side-dots .dots-label').html($(this).data('name'));
    }).on('mouseleave', function(){
        $('.side-dots .dots-label').html($('.side-dots .dot.active').data('name'));
    });
}


// Event map
const initEventMap = () => {
    if($('#eventMap').length > 0){
        if($('#display_map').val() == 1){
            const provider = new OpenStreetMapProvider();

            provider.search({ query: $('#event_address').val() }).then(function (result) {
                if(result.length > 0){
                    const map = L.map('eventMap');
                    const tiles = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZGV2ZWxvcGVycy1zZG0iLCJhIjoiY2xnM29peXgyMDYxcjNkcnAxc2d4ajRndSJ9.H2QpfzWbLw-LdrvM1DlcvA', {
                        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
                        maxZoom: 18,
                        id: 'mapbox/streets-v11',
                        tileSize: 512,
                        zoomOffset: -1,
                        detectRetina: false,
                        accessToken: 'pk.eyJ1IjoiZGV2ZWxvcGVycy1zZG0iLCJhIjoiY2xnM29peXgyMDYxcjNkcnAxc2d4ajRndSJ9.H2QpfzWbLw-LdrvM1DlcvA'
                    }).addTo(map);

                    let greenIcon = L.icon({
                        iconUrl: themePath + '/_common/images/markers/marker-icon-2x.png',
                        shadowUrl: themePath + '/_common/images/markers/marker-shadow.png',
                        iconSize:     [25, 41], // size of the icon
                        shadowSize:   [41, 41], // size of the shadow
                        iconAnchor:   [12, 41], // point of the icon which will correspond to marker's location
                        shadowAnchor: [11, 41], // the same for the shadow
                        popupAnchor:  [0, -35]  // point from which the popup should open relative to the iconAnchor
                    });

                    let marker = L.marker([result[0].y, result[0].x], {icon: greenIcon}).addTo(map);
                    let latLngs = [ marker.getLatLng() ];
                    let markerBounds = L.latLngBounds(latLngs);
                    map.fitBounds(markerBounds);
                    marker.bindPopup('<b>' + $('#event_location').val() + '</b><br>' + $('#event_address').val()).openPopup();
                }
            });
        }
    }
}


// Venue locator
let venueMap;
let dealers = [];
let allMarkers = [];
let allBounds = [];
let markersLayer = new L.markerClusterGroup();

const initVenueLocator = () => {
    if($('#venueMap').length > 0){

        $.ajax({
            url: $('#sitePath').val() + '/wp-json/wp/v2/venue?venue_cat=' + $('#venue_categories').val() + '&lang=' + $('#lang').val(),
            type: 'GET',
            cache: false,
            success: function (data) {

                $.each( data, function( key, val ) {
                    dealers.push(val);
                });

                venueMap = L.map('venueMap');

                const tiles = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZGV2ZWxvcGVycy1zZG0iLCJhIjoiY2xnM29peXgyMDYxcjNkcnAxc2d4ajRndSJ9.H2QpfzWbLw-LdrvM1DlcvA', {
                    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
                    maxZoom: 18,
                    id: 'mapbox/streets-v11',
                    tileSize: 512,
                    zoomOffset: -1,
                    detectRetina: false,
                    accessToken: 'pk.eyJ1IjoiZGV2ZWxvcGVycy1zZG0iLCJhIjoiY2xnM29peXgyMDYxcjNkcnAxc2d4ajRndSJ9.H2QpfzWbLw-LdrvM1DlcvA'
                }).addTo(venueMap);

                if (isDebug) console.log(dealers);

                printVenueOnMap(dealers);
            }
        });
    }
}

const printVenueOnMap = (dealerObj) => {

    markersLayer.clearLayers();

    allMarkers = [];
    allBounds = [];

    let greenIcon = L.icon({
        iconUrl: themePath + '/_common/images/markers/marker-icon-2x.png',
        shadowUrl: themePath + '/_common/images/markers/marker-shadow.png',
        iconSize:     [25, 41], // size of the icon
        shadowSize:   [41, 41], // size of the shadow
        iconAnchor:   [12, 41], // point of the icon which will correspond to marker's location
        shadowAnchor: [11, 41], // the same for the shadow
        popupAnchor:  [0, -35]  // point from which the popup should open relative to the iconAnchor
    });

    $.each( dealerObj, function( key, val ) {
        let marker = L.marker([val.acf.geographic_coordinates.latitude, val.acf.geographic_coordinates.longitude], {
            venue_id: val.id,
            icon: greenIcon
        });

        allMarkers.push(marker);

        let str = '';
        str += '<b>' + val.title.rendered + '</b><br>';
        str += val.acf.address;

        marker.bindPopup(str);
        markersLayer.addLayer(marker);

        allBounds.push([val.acf.geographic_coordinates.latitude, val.acf.geographic_coordinates.longitude]);
    });

    markersLayer.addTo(venueMap);

    venueMap.fitBounds(allBounds);

    // Open marker on accordion item click
    const accordionVenues = document.getElementById('accordionVenues');
    accordionVenues.addEventListener('shown.bs.collapse', event => {
        let venueId = $('.accordion-button[aria-expanded="true"]').data('id');
        markerFunction(venueId);
    });

    // Open accordion item on marker click
    venueMap.on('popupopen', function(e) {
        let marker = e.popup._source;
        $('#collapse_' + marker.options.venue_id).collapse('show');
        setTimeout(function(){
            let itemPos = $('#collapse_' + marker.options.venue_id).parent().offset().top + $('#collapse_' + marker.options.venue_id).parent().parent().parent().scrollTop() - $('#collapse_' + marker.options.venue_id).parent().parent().offsetParent().offset().top;
            $('.venue-list').animate({
                scrollTop: itemPos
            }, 400, 'easeInOutQuart');
        }, 800);
    });

}

const markerFunction = (id) => {
    for (let i in allMarkers){
        let markerID = allMarkers[i].options.venue_id;
        if (markerID == id){
            venueMap.setView([allMarkers[i]._latlng.lat, allMarkers[i]._latlng.lng], 20);
            allMarkers[i].openPopup();
        };
    }
}

$(document).ready(function() {
    initCompareProducts();
});

// Compare products
function initCompareProducts() {
    const compareSection = $('section.compare-products');
    if (compareSection.length === 0) return;

    // Fetch default products from data attributes
    const defaultProducts = [
        compareSection.data('default-product-1'),
        compareSection.data('default-product-2'),
        compareSection.data('default-product-3')
    ];

    // Reset select fields
    setTimeout(() => {
        compareSection.find('.form-select').each(function() {
            $(this).val('');
        });

        // Populate default products
        defaultProducts.forEach((productId, index) => {
            if (productId) {
                const select = compareSection.find(`.form-select[data-index="${index + 1}"]`);
                select.val(productId);
                getCompareProductData(productId, index + 1);
            }
        });
    }, 100);

    // Event listener for changes
    compareSection.on('change', '.form-select', function() {
        const select = $(this);
        const selectedValue = select.val();
        const index = select.data('index');

        if (selectedValue) {
            select.find('option[value=""]').remove();
            getCompareProductData(selectedValue, index);
            select.attr('data-selected', selectedValue);
        }

        // Disable already selected options
        const compareSelected = [];
        compareSection.find('.form-select').each(function() {
            const selected = $(this).attr('data-selected');
            if (selected) {
                compareSelected.push(selected);
            }
        });

        compareSection.find('.form-select option').each(function() {
            const option = $(this);
            if (compareSelected.includes(option.val())) {
                option.attr('disabled', true);
            } else {
                option.attr('disabled', false);
            }
        });
    });
}

const getCompareProductData = (id, index) => {
    let $prodSelect = $('.prod-select[data-index="' + index + '"]');
    $prodSelect.find('.prod-thumb').addClass('loaded');
    $prodSelect.find('.loading').removeClass('invisible');
    $prodSelect.find('.prod-thumb--img').attr('src', '#').addClass('d-none');

    $.ajax({
        url: $('#sitePath').val() + '/wp-json/wp/v2/product/' + id + '/?lang=' + $('#lang').val() + '&_embed',
        type: 'GET',
        cache: false,
        success: function (data) {
            if (isDebug) console.log(data);
            $prodSelect.find('.loading').addClass('invisible');
            $prodSelect.find('.prod-thumb--main-link').attr('href', data.link);
            $prodSelect.find('.prod-thumb--img').attr('src', data._embedded['wp:featuredmedia'][0].source_url).removeClass('d-none');
            $prodSelect.find('h2').text(data.title.rendered);
            $prodSelect.find('p').text(data.acf.compare_products_fields.claim);

            let compare_products_fields = data.acf.compare_products_fields;

            for (const key in compare_products_fields) {
                if (Object.hasOwnProperty.call(compare_products_fields, key)) {
                    $('#' + key).find('div[data-index="' + index + '"]').html(compare_products_fields[key].replace(new RegExp('\r?\n','g'), '<br />'));
                }
            }

            if($('body').hasClass('lm-home')){
                let prod_price = data.custom_fields._price;
                if(Array.isArray(prod_price)) {
                    $prodSelect.find('.price span.from').hide();
                    prod_price = Number(prod_price[0]).toLocaleString(undefined, {minimumFractionDigits: 2}) + ' - ' + Number(prod_price[1]).toLocaleString(undefined, {minimumFractionDigits: 2});
                } else {
                    $prodSelect.find('.price span.from').show();
                    prod_price = Number(data.custom_fields._price).toLocaleString(undefined, {minimumFractionDigits: 2});
                }

                $prodSelect.find('.price span.num').text(prod_price);
                $prodSelect.find('.price').show();
                $prodSelect.find('.prod-thumb--main-link').attr('href', $('#sitePath').val() + '/?p=' + data.acf.product_landing_page);
                $prodSelect.find('.btn-explore-home').attr('href', $('#sitePath').val() + '/?p=' + data.acf.product_landing_page).removeClass('d-none');
                $('#lower_cta').find('div[data-index="' + index + '"] .btn-explore-home').attr('href', $('#sitePath').val() + '/?p=' + data.acf.product_landing_page).removeClass('d-none');
                if(data.composite_layout === "single"){
                    $prodSelect.find('.btn-configure').attr('href', data.link).removeClass('d-none');
                    $prodSelect.find('.btn-buy').addClass('d-none');
                    $('#lower_cta').find('div[data-index="' + index + '"] .btn-configure').attr('href', data.link).removeClass('d-none');
                    $('#lower_cta').find('div[data-index="' + index + '"] .btn .configure').show();
                    $('#lower_cta').find('div[data-index="' + index + '"] .btn .buy').hide();
                } else {
                    $prodSelect.find('.btn-configure').addClass('d-none');
                    $prodSelect.find('.btn-buy').attr('href', data.link).removeClass('d-none');
                    $('#lower_cta').find('div[data-index="' + index + '"] .btn-configure').attr('href', data.link).removeClass('d-none');
                    $('#lower_cta').find('div[data-index="' + index + '"] .btn .configure').hide();
                    $('#lower_cta').find('div[data-index="' + index + '"] .btn .buy').show();
                }
            } else {
                $prodSelect.find('.price span').text('');
                $prodSelect.find('.price').hide();
                $prodSelect.find('.btn-requestinfo').attr('href', sitePath + wpmlLangPath + '/about-us/contact-us/?int=Commercial%20Machines&prod=' + data.title.rendered).removeClass('d-none');
                $prodSelect.find('.btn-explore').attr('href', data.link).removeClass('d-none');
                $('#lower_cta').find('div[data-index="' + index + '"] .btn-requestinfo').attr('href', sitePath + wpmlLangPath + '/about-us/contact-us/?int=Commercial%20Machines&prod=' + data.title.rendered).removeClass('d-none');
                $('#lower_cta').find('div[data-index="' + index + '"] .btn-explore').attr('href', data.link).removeClass('d-none');
            }

            $('.compare-products--body').removeClass('d-none');
        },
        error: function (xhr, status, error) {
            console.error(`Error fetching product data: ${status} - ${error}`);
            $prodSelect.find('.loading').addClass('invisible');
        }
    });
};


// Energy saver
const initEnergySaver = () => {
    idle({
        onIdle: energySaverShow,
        idle: 600000
    }).start();

    function energySaverShow() {
        $(".energy-saver").on("click", energySaverHide).fadeIn();
    }

    function energySaverHide() {
        $(".energy-saver").off("click").fadeOut();
    }
}


// initScrollCategory
const initScrollCategory = () => {
    const filters = document.querySelectorAll('.page-title .filters .filters--inner .scrolling');

    if(deviceWidth > 1024){
        filters.forEach(ele => {
            ele.scrollLeft = 0;
            let pos = { top: 0, left: 0, x: 0, y: 0 };

            const mouseDownHandler = function (e) {
                e.preventDefault();

                pos = {
                    // The current scroll
                    left: ele.scrollLeft,
                    top: ele.scrollTop,
                    // Get the current mouse position
                    x: e.clientX,
                    y: e.clientY,
                };

                ele.addEventListener('mousemove', mouseMoveHandler);
                document.addEventListener('mouseup', mouseUpHandler);
            };

            const mouseMoveHandler = function (e) {
                e.preventDefault();

                // How far the mouse has been moved
                const dx = e.clientX - pos.x;
                const dy = e.clientY - pos.y;

                // Scroll the element
                ele.scrollTop = pos.top - dy;
                ele.scrollLeft = pos.left - dx;

                // Change the cursor and prevent user from selecting the text
                ele.style.cursor = 'grabbing';
                ele.style.userSelect = 'none';
            };

            const mouseUpHandler = function (e) {
                e.preventDefault();

                ele.removeEventListener('mousemove', mouseMoveHandler);
                ele.removeEventListener('mouseup', mouseUpHandler);

                ele.style.cursor = 'grab';
                ele.style.removeProperty('user-select');
            };

            ele.addEventListener('mousedown', mouseDownHandler);
        });
    }

    // Scroll categories on current category position
    $('.page-title .filters .filters--inner .scrolling').each(function(i, el){
        if($(el).find('li.current').length > 0){
            var posLeft = $(el).find('li.current').offset().left - $(el).outerWidth() / 2 + $(el).find('li.current').outerWidth() / 2;
            $(el).scrollLeft(posLeft);
        }
    });
}


// initFooter
const initFooter = () => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))
}

// initDefaultCookieBanner
const initDefaultCookieBanner = () => {
    const defaultCookieBanner = document.getElementById('defaultCookieBanner');
    const defaultCookieBannerAccept = document.getElementById('defaultCookieBannerAccept');
    if(defaultCookieBannerAccept){
        defaultCookieBannerAccept.addEventListener('click', function(){
            defaultCookieBanner.classList.add('d-none');
            let CookieDate = new Date;
            CookieDate.setFullYear(CookieDate.getFullYear() +10);
            document.cookie = "lamarzocco-default-cookie-banner=true; path=/; expires=" + CookieDate.toUTCString() + ";";
        }, false);
    }
}

// CookieYes custom script
const initCookieYesCustomScript = () => {
    setTimeout(function(){
        let btnBadge = document.querySelector('.cky-btn-revisit');
        let btnOpenCookieBanner = document.querySelector('#btnOpenCookieBanner');
        if(btnBadge && btnOpenCookieBanner){
            btnOpenCookieBanner.addEventListener('click', e => {
                btnBadge.click();
            });
        }
    }, 3000);
}


/* Ready callback function */
ready(() => {
    deviceWidth = $(window).width();
    deviceHeight = $(window).height();

    themePath = $('#themePath').val();
    sitePath = $('#sitePath').val();
    wpmlLangPath = $('#wpmlLangPath').val();

    initWebpackVersion()
    initMainMenu()
    checkScrollTop()
    pagesVertSideImg()
    initProductPage()
    initWooProductPage()
    initMyAccount()
    initEventMap()
    initVenueLocator()
    initCompareProducts()
    initAnimations()
    initEnergySaver()
    initScrollCategory()
    initFooter()
    initDefaultCookieBanner()
    initCookieYesCustomScript()

    // Controllo la presenza di anchor e effettuo uno slide della pagina
    urlHash = location.hash;
    if (urlHash != "") {
        urlHash = urlHash.substr(1, urlHash.length);
        setTimeout(function () {
            scrollToHash(urlHash);
        }, 500);
    }

    // Accessibility: aria-expanded true/false on click
    $('.hamburger').each(function(i, el){
        $(el).on('click', function(){
            $(this).attr('aria-expanded', function(index, attr){
                return attr == "false" ? "true" : "false";
            });
        });
    });

    // BackgroundCheck init
    BackgroundCheck.init({
        targets: '.check-color-target, .check-color-target-logo, .check-color-target-icons',
        images: $('.check-color-images').length > 0 ? '.check-color-images' : '.check-color-target-fake',
        threshold: 50,
        //debug: true
    });

    // btnScrollUpPage
    $('#btnScrollUpPage').on('click', function(){
        if(scrollSpy)
            scrollSpy.dispose();
        scrollToSection('page-top');
    });

    // Swiper
    let sliderHeroMain = document.querySelectorAll('section.hero-main .swiper');
    if (sliderHeroMain) {
        sliderHeroMain.forEach(el => {
            let swiperHeroMain = new Swiper(el, {
                modules: [Navigation, Pagination, Autoplay],
                speed: 1000,
                loop: true,
                autoHeight: true,
                slidesPerView: 1,
                spaceBetween: 0,
                autoplay: {
                    delay: 8000
                },
                pagination: {
                    el: el.querySelector('.swiper-pagination'),
                    clickable: false
                },
                navigation: {
                    nextEl: el.querySelector('.swiper-navigation-btns .btn-next'),
                    prevEl: el.querySelector('.swiper-navigation-btns .btn-prev'),
                    lockClass: 'd-none'
                },
                on: {
                    afterInit: function(swiper) {
                        el.querySelector('.swiper-navigation-btns').classList.remove('invisible');
                        el.querySelector('.swiper-pagination').classList.remove('invisible');
                        $('section.hero-main .swiper .swiper-slide').each(function(){
                            if($(this).hasClass('swiper-slide-active')){
                                $(this).find('.video-yt').attr('src', $(this).find('.video-yt').data('src'));
                                $(this).find('.video-vi').attr('src', $(this).find('.video-vi').data('src'));
                                $(this).find('.video-vi-mobile').attr('src', $(this).find('.video-vi-mobile').data('src'));
                            }
                        });
                    },
                    slideChangeTransitionStart: function (swiper) {
                        $('section.hero-main .swiper .swiper-slide').each(function(){
                            if($(this).hasClass('swiper-slide-active')){
                                $(this).find('.video-yt').attr('src', $(this).find('.video-yt').data('src'));
                                $(this).find('.video-vi').attr('src', $(this).find('.video-vi').data('src'));
                                $(this).find('.video-vi-mobile').attr('src', $(this).find('.video-vi-mobile').data('src'));
                            }
                        });
                    },
                    slideChangeTransitionEnd: function (swiper) {
                        if(!$('body').hasClass('menu-is-active')){
                            BackgroundCheck.refresh();
                        }
                        $('section.hero-main .swiper .swiper-slide').each(function(){
                            if(!$(this).hasClass('swiper-slide-active')){
                                $(this).find('.video-yt').attr('src', '');
                                $(this).find('.video-vi').attr('src', '');
                                $(this).find('.video-vi-mobile').attr('src', '');
                            }
                        });
                    }
                }
            });
        });
    }

    let sliderItem = document.querySelectorAll('section.item-slider .swiper, section.instagram-slider .swiper');
    if (sliderItem) {
        sliderItem.forEach(el => {
            let swiperItem = new Swiper(el, {
                modules: [Navigation, Pagination],
                speed: 1000,
                loop: false,
                autoHeight: false,
                slidesPerView: 1,
                spaceBetween: 30,
                pagination: {
                    el: el.querySelector(".swiper-pagination"),
                    type: "progressbar",
                },
                navigation: {
                    nextEl: el.querySelector('.swiper-navigation-btns .btn-next'),
                    prevEl: el.querySelector('.swiper-navigation-btns .btn-prev'),
                    lockClass: 'd-none'
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2
                    },
                    992: {
                        slidesPerView: 3
                    },
                    1200: {
                        slidesPerView: 4
                    }
                }
            });
        });
    }

    let sliderProdLandingGallery = document.querySelector('section.gallery .swiper');
    if (sliderProdLandingGallery) {
        let sliderLength = sliderProdLandingGallery.querySelectorAll('.swiper-slide');
        let sliderLoop = sliderLength.length >= 5 ? true : false;
        swiperProdLandingGallery = new Swiper(sliderProdLandingGallery, {
            modules: [Navigation],
            speed: 1000,
            loop: false,
            slidesPerView: 1,
            spaceBetween: 15,
            navigation: {
                nextEl: sliderProdLandingGallery.querySelector('.swiper-navigation-btns .btn-next'),
                prevEl: sliderProdLandingGallery.querySelector('.swiper-navigation-btns .btn-prev'),
                lockClass: 'd-none'
            },
            breakpoints: {
                768: {
                    loop: sliderLoop,
                    slidesPerView: 2
                },
                1024: {
                    loop: sliderLoop,
                    slidesPerView: 2,
                    spaceBetween: 25
                }
            }
        });
    }

    let sliderProdLandingModalGallery = document.querySelector('.prod-landing .gallery-modal .swiper');
    if (sliderProdLandingModalGallery) {
        swiperProdLandingModalGallery = new Swiper(sliderProdLandingModalGallery, {
            modules: [Navigation],
            speed: 1000,
            loop: false,
            slidesPerView: 1,
            slidesPerGroup: 1, // Only scroll one slide at a time
            spaceBetween: 15,
            centeredSlides: true,
            navigation: {
                nextEl: '.gallery-modal .btn-next',
                prevEl: '.gallery-modal .btn-prev',
                lockClass: 'd-none'
            },
            // Force all breakpoints to show only one slide
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    slidesPerGroup: 1
                },
                768: {
                    slidesPerView: 1,
                    slidesPerGroup: 1
                },
                1024: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 25
                }
            },
            on: {
                init: function() {
                    this.update();
                }
            }
        });
    }

    let sliderProdLandingVideo = document.querySelector('section.video-gallery .swiper');
    if (sliderProdLandingVideo) {
        swiperProdLandingVideo = new Swiper(sliderProdLandingVideo, {
            modules: [Navigation],
            speed: 1000,
            loop: false,
            slidesPerView: 1,
            spaceBetween: 15,
            slideToClickedSlide: true,
            navigation: {
                nextEl: sliderProdLandingVideo.querySelector('.swiper-navigation-btns .btn-next'),
                prevEl: sliderProdLandingVideo.querySelector('.swiper-navigation-btns .btn-prev'),
                lockClass: 'd-none'
            },
            breakpoints: {
                768: {
                    loop: true
                },
                1024: {
                    loop: true,
                    spaceBetween: 25
                }
            }
        });
    }

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll('.needs-validation')
    Array.from(forms).forEach(form => {
        let allInputs = form.querySelectorAll('input, select, textarea');
        allInputs.forEach(function(el){
            el.addEventListener('change', function(event){
                if(el.checkValidity()){
                    el.removeAttribute('aria-invalid');
                } else {
                    el.setAttribute('aria-invalid', 'true');
                }
            });
        });

        form.addEventListener('submit', event => {
            form.classList.add('was-validated');

            let validFields = form.querySelectorAll('*:valid');
            let invalidFields = form.querySelectorAll('*:invalid');
            validFields.forEach(function(validField){
                validField.removeAttribute('aria-invalid');
            });
            invalidFields.forEach(function(invalidField){
                invalidField.setAttribute('aria-invalid', 'true');
            });

            if (!form.checkValidity()) {
                event.preventDefault()
                event.stopPropagation()
            } else {
                if(form.classList.contains('form-nl')){
                    event.preventDefault()
                    event.stopPropagation()

                    if(form.classList.contains('form-mailchimp')){
                        register_MC($('#mc-embedded-subscribe-form'));
                    }
                    if(form.classList.contains('form-omnisend')){
                        register_OS($('#mc-embedded-subscribe-form'));
                    }
                }
            }
        }, false)
    })

    // Initialize navigation handlers for all modal gallery controls

    // Add this after the swiper initialization
    if (swiperProdLandingModalGallery) {
        // Manual navigation binding as a backup
        document.querySelectorAll('.gallery-modal .btn-next, .btn-nav-arrow-desktop.btn-next').forEach(btn => {
            btn.addEventListener('click', function() {
                swiperProdLandingModalGallery.slideNext();
            });
        });
        
        document.querySelectorAll('.gallery-modal .btn-prev, .btn-nav-arrow-desktop.btn-prev').forEach(btn => {
            btn.addEventListener('click', function() {
                swiperProdLandingModalGallery.slidePrev();
            });
        });
    }
    
    // Global variable to store the modal swiper instance
    window.modalSwiperInstance = null;
    
    // Apply a simpler, more reliable fix for WooCommerce product gallery modal
    window.fixWooGalleryModal = function() {
        // Get the modal element
        const galleryModal = document.getElementById('galleryModal');
        if (!galleryModal) return;
        
        // Pre-initialize the modal Swiper before any clicks happen
        // This ensures modal is ready before being shown
        const sliderElement = document.querySelector('.modal.gallery-modal .swiper');
        if (sliderElement) {
            // Pre-initialize the Swiper instance so it's ready
            if (window.modalSwiperInstance) {
                window.modalSwiperInstance.destroy();
            }
            
            window.modalSwiperInstance = new Swiper(sliderElement, {
                modules: [Navigation],
                speed: 0, // Initially set to 0 for immediate positioning
                slidesPerView: 1,
                spaceBetween: 15,
                initialSlide: 0,
                watchOverflow: true,
                grabCursor: true,
                navigation: {
                    nextEl: '.gallery-modal .btn-next',
                    prevEl: '.gallery-modal .btn-prev'
                },
                // Make sure slides are loaded when initialized
                preloadImages: true,
                updateOnImagesReady: true,
                // Add proper handling of images
                on: {
                    init: function() {
                        // Ensure images maintain aspect ratio and stay in viewport
                        const thumbs = document.querySelectorAll('.gallery-modal .gallery--thumb');
                        thumbs.forEach(thumb => {
                            thumb.style.maxHeight = '90vh';
                            thumb.style.objectFit = 'contain';
                        });
                    }
                }
            });
        }
        
        // Add index attributes to all thumbnails
        $('.single-prod--gallery .swiper-slide a').each(function(index) {
            $(this).attr('data-slide-index', index);
        });
        
        // Handle thumbnail clicks
        $('.single-prod--gallery .swiper-slide a').off('click').on('click', function(e) {
            e.preventDefault();
            
            // Get the index from the clicked thumbnail
            const clickedIndex = parseInt($(this).attr('data-slide-index'), 10);
            
            // Set the slide directly before showing the modal
            if (window.modalSwiperInstance) {
                // Use slideTo with no animation before the modal is shown
                window.modalSwiperInstance.slideTo(clickedIndex, 0);
            }
            
            // Show the modal
            const bsModal = new Modal(galleryModal);
            bsModal.show();
        });
        
        // When modal is fully shown, ensure navigation works
        $(galleryModal).off('shown.bs.modal').on('shown.bs.modal', function() {
            // Now that the modal is visible, restore normal animation speed
            if (window.modalSwiperInstance) {
                window.modalSwiperInstance.params.speed = 400;
                window.modalSwiperInstance.update();
                
                // Refresh all slides to ensure they're properly constrained
                const slides = document.querySelectorAll('.gallery-modal .swiper-slide');
                slides.forEach(slide => {
                    slide.style.height = 'auto';
                    slide.style.maxHeight = '90vh';
                    slide.style.display = 'flex';
                    slide.style.alignItems = 'center';
                });
                
                // Make sure images are properly sized
                const thumbs = document.querySelectorAll('.gallery-modal .gallery--thumb');
                thumbs.forEach(thumb => {
                    thumb.style.maxHeight = '90vh';
                    thumb.style.objectFit = 'contain';
                });
            }
            
            // Ensure navigation buttons work
            $('.gallery-modal .btn-next').off('click.fixNav').on('click.fixNav', function() {
                if (window.modalSwiperInstance) {
                    window.modalSwiperInstance.slideNext();
                }
            });
            
            $('.gallery-modal .btn-prev').off('click.fixNav').on('click.fixNav', function() {
                if (window.modalSwiperInstance) {
                    window.modalSwiperInstance.slidePrev();
                }
            });
        });
        
        // When modal is hidden, clean up
        $(galleryModal).off('hidden.bs.modal').on('hidden.bs.modal', function() {
            // Don't destroy, just update and reset for next use
            if (window.modalSwiperInstance) {
                window.modalSwiperInstance.update();
            }
        });
    };
    
    // Call our fix function
    window.fixWooGalleryModal();
})

const register_OS = ($form) => {
    nl_msg('Please wait...', 'alert-light');

    const captchaIndex = [];
    captchas.map((captcha, index) => {
        if('newsletterCaptcha' === captcha.id)
            captchaIndex.push(index);
    });

    if(!captchaIndex)
        return false;

    var response = grecaptcha.getResponse(captchaIndex[0]);

    if(response.length == 0) {
        // reCaptcha not verified
        document.getElementById('recaptchaAlertNl').classList.remove('d-none');
        jQuery('#nl_msg').hide();
    } else {
        // reCaptcha verified
        document.getElementById('recaptchaAlertNl').classList.add('d-none');
        jQuery.ajax({
            type		: $form.attr('method'),
            url			: themePath + '/include/vendors/omnisend/send-omnisend.php',
            data		: $form.serialize(),
            cache       : false,
            dataType    : 'json',
            contentType : "application/json; charset=utf-8",
            error       : function(err) {
                nl_msg('Could not connect to the registration server. Please try again later.', 'alert-danger');
            },
            success     : function(data) {
                if (data.error) {
                    // Something went wrong, do something to notify the user
                    nl_msg(data.error, 'alert-danger');
                } else {
                    // Success message
                    nl_msg('Thank you for subscribing!', 'alert-light');
                    reset_form_nl();
                }
            }
        });
    }

}

const register_MC = ($form) => {
    nl_msg('Please wait...', 'alert-light');
    jQuery.ajax({
        type		: $form.attr('method'),
        url			: $form.attr('action'),
        data		: $form.serialize(),
        cache       : false,
        dataType    : 'jsonp',
		jsonp		: 'c',
        contentType : "application/json; charset=utf-8",
        error       : function(err) {
            nl_msg('Could not connect to the registration server. Please try again later.', 'alert-danger');
		},
        success     : function(data) {
            if (data.result != "success") {
                // Something went wrong, do something to notify the user
				nl_msg(data.msg, 'alert-danger');
            } else {
				// Success message
				nl_msg(data.msg, 'alert-light');
                reset_form_nl();
            }
        }
    });
}

const nl_msg = (txt, type) => {
    jQuery('#nl_msg').removeClass('alert-danger alert-light');
    jQuery('#nl_msg').html(txt).addClass(type).fadeIn();
}

const reset_form_nl = () => {
    $('.form-nl').removeClass('was-validated')
    jQuery('#mc_embed_signup input[type="text"]').val('');
    jQuery('#mc_embed_signup input[type="email"]').val('');
}

// Google reCaptcha
const captchas = [...document.querySelectorAll('.g-recaptcha')];
var CaptchaCallback = function() {
    captchas.forEach(captcha => {
        const id = captcha.id;
        if(id){
            grecaptcha.render(id, {'sitekey' : '6LeT1VsUAAAAAFqGDdoxVjtmtLwTp-vWCUNeouHC'});
        }
    });
};

window.CaptchaCallback = CaptchaCallback;
window.scrollToSection = scrollToSection;
window.initWooProductConfigurator = initWooProductConfigurator;
window.Tooltip = Tooltip;
